export const iconFontAwesomeConnectivityCloudArrowUp = (
	<i className="fa-solid fa-cloud-arrow-up"></i>
);
